/**
 * useShareBaseUrl — origine ABSOLUE du site courant pour les URLs
 * auto-référentes des meta de partage (og:image via /api/og/*, fallback
 * /og-image.png).
 *
 * Pourquoi pas "https://donoor.org" en dur : les pages publiques tournent
 * aussi sur staging.donoor.org (et les préviews Vercel). Une og:image en
 * dur vers la prod y référence des slugs/assets qui n'existent QUE sur
 * l'environnement courant → « Image failed to load » sur Discord/WhatsApp
 * quand on partage un lien staging (bug Karim 2026-07-02).
 *
 * `useRequestURL()` résout l'origine réelle de la requête côté SSR
 * (x-forwarded-host géré par Nuxt/Vercel) et `window.location` côté
 * client → chaque environnement génère des og:image qui pointent vers
 * lui-même, où le slug/asset existe.
 *
 * NOTE : les URLs CANONIQUES restent en dur sur https://donoor.org — c'est
 * voulu (seule la prod est indexable, le canonical doit y pointer).
 */
export function useShareBaseUrl(): string {
  return useRequestURL().origin;
}
